export default __webpack_public_path__ + "static/desktop-bg-bottom-leaves-5a02d0bdb98568f5cd79dfd3bd6b4d99.png";